import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetTerms = (currentYearOnly = true) => {
    const {
        isFetching: isLoading, data: terms, error,
    } = useQuery({
        queryKey: ["terms", currentYearOnly],
        queryFn: () => axiosManager.get$("/parent/api/terms", { params: { currentYearOnly } }).then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    return { isLoading, terms, error };
};
